/**
 * Token 本地存储类
 * 存放在 localStorage
 * @author Jianbo
 * @time   2020-02-25
 */

// localStorage token key
export const AUTH_TOKEN_KEY = 'WFC_AUTH_TOKEN'

class TokenStorage {
  /**
   * 获取token
   * @return  String
  */
  static getToken () {
    return window.localStorage.getItem(AUTH_TOKEN_KEY)
  }

  /**
   * 保存token
   * @param  String { token }
   * @return undefined
   */
  static saveToken ({ token }) {
    return window.localStorage.setItem(AUTH_TOKEN_KEY, token)
  }

  /**
   * 清除token
   */
  static removeToken () {
    return window.localStorage.removeItem(AUTH_TOKEN_KEY)
  }
}

export default TokenStorage
